module.exports = __webpack_public_path__ + "img/s6img2_big.ea21181.942b73bf.png";